import { render } from "./Manikura.vue?vue&type=template&id=2a7d4f4e&scoped=true"
import script from "./Manikura.vue?vue&type=script&lang=js"
export * from "./Manikura.vue?vue&type=script&lang=js"

import "./Manikura.vue?vue&type=style&index=0&id=2a7d4f4e&lang=css"
import "./Manikura.vue?vue&type=style&index=1&id=2a7d4f4e&scoped=true&lang=css"
import "./Manikura.vue?vue&type=style&index=2&id=2a7d4f4e&scoped=true&lang=css"
import "./Manikura.vue?vue&type=style&index=3&id=2a7d4f4e&scoped=true&lang=css"
import "./Manikura.vue?vue&type=style&index=4&id=2a7d4f4e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a7d4f4e"]])

export default __exports__